"use client";
import { STORE_KEYS } from "app/constants";
import { useStaticStore } from "app/hooks";
import { useEffect, useRef } from "react";
import { Toast } from "./Toast";

export default function Dialog({
  children,
  storeKey,
  className,
  preventClose,
  onClosedByClickOutside,
}: {
  children: React.ReactNode;
  storeKey: STORE_KEYS;
  className?: string;
  preventClose?: boolean;
  onClosedByClickOutside?: () => void;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const { data: isOpen, mutate: setIsOpen } = useStaticStore(storeKey, false);
  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [isOpen]);
  return (
    <dialog
      className={"dialog" + (className ? " " + className : "")}
      ref={dialogRef}
      onClick={(e) => {
        if (!preventClose) {
          setIsOpen(false);
          if (onClosedByClickOutside && typeof onClosedByClickOutside === "function") {
            onClosedByClickOutside();
          }
        }
      }}
      onCancel={(e) => {
        if (preventClose) {
          e.preventDefault();
        }
      }}
    >
      <div className="dialog-content-wrap" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
      <Toast />
    </dialog>
  );
}
